const context = {
    CartSubtotal: 'Cart Subtotal',
    CheckoutLink: {
        Url: '/shop/cart',
        Text: 'Checkout'
    },
    EmptyCartPrice: '-',
    Flavor: 'Flavor:',
    Items: '({0} items)',
    Packaging: 'Packaging:',
    Quantity: 'Qty',
    Remove: 'Remove',
    RxForm: 'Rx Form:',
    StrengthSize: 'Strength / Size:',
    StrengthSizeSupplies: 'Strength / Size Supplies:',
    Subscribe: 'Subscribe With Never Forget®',
    YourShoppingCartEmpty: 'Your Shopping Cart is Empty'
};

export {
    context
};
